import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Visitor } from 'src/app/models/visitor';
import { MatSelectChange } from '@angular/material/select';
import { ScreenType } from 'src/app/enums/ScreenType';
import { MatDialog } from '@angular/material/dialog';
import { HostApprovalComponent } from 'src/app/modules/security-pass/components/host-approval/host-approval.component';
import { Capacitor } from '@capacitor/core';
@Component({
  selector: 'app-pending-host-approvals',
  templateUrl: './pending-host-approvals.component.html',
  styleUrls: ['./pending-host-approvals.component.scss'],
})
export class PendingHostApprovalsComponent {
  @Input() set pendingVisitorData(val: Visitor[]) {
    if (val) {
      this.visitorData = val;
      // this.dataSource = val;
      this.dataSource = this.visitorData.filter(
        (index) =>
          index.securityStatus == 0 &&
          index.isPreApproved != 'true' &&
          index.isGateEntry == '1'
      );
      // this.getOnlyPendingVisitors(val);
    }
  }
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  @Output() onClosePendingVisitorSection = new EventEmitter<any>();
  displayedColumns = [
    'no',
    'visname',
    'hostname',
    'date',
    'purpose',
    'security',
  ];
  screenInfo: ScreenType;
  showWaitingSection = false;
  expandedDetail = '';
  visitorData: Visitor[];
  dataSource: Visitor[] = [];

  constructor(private dialog: MatDialog) {}

  onShowDetails(val: Visitor) {}
  getOnlyPendingVisitors(val: Visitor[]) {
    this.visitorData = val.filter((index) => index.isGateEntry == '1');
    this.dataSource = this.visitorData;
    return val.filter((index) => index.isGateEntry == '1');
  }
  onChooseTypeChange(val: MatSelectChange) {
    if (val.value == 1) {
      this.dataSource = this.visitorData.filter(
        (index) => index.securityStatus == 1
      );
    } else if (val.value == 2) {
      this.dataSource = this.visitorData.filter(
        (index) =>
          index.securityStatus == 0 &&
          index.isPreApproved != 'true' &&
          index.isGateEntry == '1'
      );
    } else if (val.value == 3) {
      this.dataSource = this.visitorData.filter(
        (index) => index.securityStatus == -1
      );
    } else if (val.value == 4) {
      this.dataSource = this.visitorData.filter(
        (index) => index.securityStatus == 3
      );
    } else if (val.value == 5) {
      this.dataSource = this.visitorData.filter(
        (index) => index.isPreApproved == 'true'
      );
    } else {
      this.dataSource = this.visitorData;
    }
  }
  onClose() {
    this.onClosePendingVisitorSection.emit();
  }
  openApprovalPage(visitor: Visitor) {
    if (this.screenInfo == ScreenType.Mobile) {
      const dialogRef = this.dialog.open(HostApprovalComponent, {
        disableClose: true,
        data: visitor,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
        } else {
          window.location.reload();
        }
      });
    } else {
      const platform = Capacitor.getPlatform();
      const currentURL =
        platform == 'android'
          ? 'https://portal.aumye.com/'
          : window.location.href;
      const url = new URL(currentURL);
      const visitorUrl =
        url.origin + '/security/host-approval?id=' + visitor.visitorID;
      window.open(visitorUrl, '_blank');
    }
  }
  getFormatedDate(val: any) {
    // let localDate = new Date(val);
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  isOpenApprovalSection(visitor: any): boolean {
    if (visitor && visitor.inviteCreateDate) {
      const currentDate = new Date();
      const inviteCreateDate = new Date(visitor.inviteCreateDate + 'Z');

      const timeDifferenceInMilliseconds =
        currentDate.getTime() - inviteCreateDate.getTime();

      const timeDifferenceInHours =
        timeDifferenceInMilliseconds / (1000 * 60 * 60);

      return timeDifferenceInHours <= 2;
    }

    // Log when the visitor or inviteCreateDate is not valid
    console.log('Invalid visitor data or inviteCreateDate is missing.');
    return false;
  }

  // isOpenApprovalSection(visitor: any): boolean {
  //   if (visitor && visitor.inviteCreateDate) {
  //     const currentDate = new Date();
  //     const timeDifferenceInMilliseconds =
  //       currentDate.getTime() - new Date(visitor.inviteCreateDate).getTime();
  //     const timeDifferenceInHours =
  //       timeDifferenceInMilliseconds / (1000 * 60 * 60);
  //     return timeDifferenceInHours <= 2;
  //   }
  //   return false;
  // }
  ScreenType = ScreenType;
}
